import { CSSProperties } from "react";

import { forwardRef } from "react";
import { Swiper, SwiperSlide, SwiperProps } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { merge, map, chunk } from "lodash-es";
import { goToPage, getChannel } from "@/utils/tools";
import { NativeByUrlList } from "@/utils/common";

import "swiper/css";
import "swiper/css/pagination";
import styles from "./style.module.less";
import { trackGdp } from "@/utils/gio-report";

const DEFAULT_CONFIG = {
  centeredSlides: true, // 移动端常见居中模式
  touchStartPreventDefault: false, // 是否允许原生滚动
  autoplay: {
    delay: 3000,
    pauseOnMouseEnter: true,
    disableOnInteraction: false,
  },
  pagination: {
    clickable: true,
    type: "bullets",
    bulletClass: "swiper-pagination-bullet",
    bulletActiveClass: "swiper-pagination-bullet-active",
    modifierClass: "swiper-pagination-",
  },
  modules: [Autoplay, Pagination], // 4. 注册Pagination模块
};

export interface KingKongItem {
  imgUrl: string;
  name: string;
  href: string;
  key: string | number;
  jumpUrlMap: Record<string, string>;
}

export interface KingKongAreaProps {
  items: KingKongItem[];
  rows: number;
  cols: number;
  style?: CSSProperties;
  swiperConfig?: SwiperProps;
  showPagination?: boolean;
  autoplay?: boolean;
  bgImg: string;
  activityInfo: Object;
}

const KingKongArea = forwardRef<HTMLLIElement, KingKongAreaProps>(
  (
    {
      items,
      rows,
      cols,
      style,
      swiperConfig,
      showPagination,
      autoplay,
      bgImg,
      activityInfo,
    },
    ref,
  ) => {
    const handleItemClick = (item: KingKongItem, index: any) => {
      setContentOverflow(true);

      // 检查是否有新的 jumpUrlMap 格式
      if (item?.jumpUrlMap) {
        // 使用新的 jumpUrlMap 格式
        NativeByUrlList(item.jumpUrlMap);
      } else if (item.href) {
        // 兜底使用旧的 href 格式
        goToPage(item.href);
      }

      trackGdp("P20189", "B004", {
        trackName: "充电_营销专题页_组件点击",
        origin: getChannel(),
        userType: "",
        versionId: activityInfo.versionCode,
        pageId: activityInfo.pageCode,
        ComponentCode: activityInfo.moduleId,
        description: activityInfo.moduleRemark,
        type: activityInfo.moduleType,
        activityId: activityInfo.connectedActivitiesId,
        clickLocation: `金刚区点击-${index + 1}`,
      });
      setTimeout(() => {
        setContentOverflow(false);
      }, 1000);
    };

    const setContentOverflow = (hidden: boolean) => {
      document.body.style.overflow = hidden ? "hidden" : "auto";
      document.body.style.pointerEvents = hidden ? "none" : "";
      const configPage = document.getElementById("configPage");
      if (configPage) {
        configPage.style.overflow = hidden ? "hidden" : "auto";
      }
    };

    const swiperList = chunk(items, rows * cols);
    const config = merge(DEFAULT_CONFIG, swiperConfig);
    const pagination = showPagination ? config.pagination : undefined;
    const autoplayConfig = autoplay ? config.autoplay : undefined;

    return (
      <div
        className={styles["xply-king-kong-area"]}
        style={{
          backgroundImage: `url(${bgImg})`,
          backgroundSize: "100% auto",
        }}
      >
        <Swiper
          ref={ref}
          {...config}
          pagination={pagination}
          autoplay={autoplayConfig}
        >
          {map(swiperList, (swiperItem, index) => (
            <SwiperSlide key={index}>
              <div
                className={styles["xply-king-kong-area-inner"]}
                style={style}
              >
                {map(swiperItem, (item, index1) => (
                  <div
                    key={item.key || index1}
                    className={styles["xply-king-kong-item"]}
                    onClick={() => handleItemClick(item, index1)}
                    style={{ width: `${100 / cols}%` }}
                  >
                    <img
                      className={styles["xply-king-kong-icon"]}
                      src={item.imgUrl}
                      alt={item.name}
                    />
                    <div className={styles["xply-king-kong-text"]}>
                      {item.name}
                    </div>
                  </div>
                ))}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  },
);

export default KingKongArea;
